import { StepComponentType } from '@icc/configurator/shared';
import { CanvasComponent } from './canvas/canvas.component';
import { ProductDetailsComponent } from '@icc/configurator/pages';

export const coupledWindowStepsMap: {
    [stepId: string]: StepComponentType;
} = {
    canvas: CanvasComponent
};
